import { AfterViewInit, Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-user-home',
  templateUrl: './user-home.component.html',
  styleUrls: ['./user-home.component.css']
})


export class UserHomeComponent implements OnInit {

  authToken = localStorage.getItem('auth');

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}` }),
    withCredentials: true,
  };

  businessID = this.route.snapshot.params.businessID;
  openings = [];
  open_profiles = 0;
  wellfareAreas = [];
  wishList = [];
  show_mdtypes = [];
  mdTypes = [];
  selectedMdType = 'all';
  currentProfile;
  isLoading = false;
  out_of_results = false;
  contains_query_params = false;
  currentSkip = 0;
  current_epoch = new Date().getTime();
  opening;
  isValid = false;
  storable_profile;
  employer_lists = [];
  contacted_by = [];
  rights = [
    {
      highlighted: "Kaikilla",
      normal: " organisaatiossasi on oikeus nähdä profiili",
      icon_src: "../../assets/icons/people.svg",
      selected: false,
      id: 'all_in_organization',
      can_be_seen_by_others_in_same_business: true,
    },
    {
      highlighted: "Vain",
      normal: " sinulla on oikeus",
      icon_src: "../../assets/icons/lock_icon.svg",
      selected: false,
      id: 'only_me',
      can_be_seen_by_others_in_same_business: false,
    }
  ]
  workPossibilities = [

    { label: 'Keikka', value: 'buy-service' },
    { label: 'Kesätyö', value: 'summer-job' },
    { label: 'Harjoittelu', value: 'trainee' },
    { label: 'Erikoistuminen', value: 'specialty' },
    { label: 'Vakituinen', value: 'full-time' },
    { label: 'Osa-aikainen', value: 'part-time' },
    { label: 'Määräaikainen', value: 'fixed-term' },
    { label: 'Virka', value: 'service' },
  ];
  already_in_list = [];

  tags = [];
  tagsSearchControl = new FormControl('');
  tagsSuggestions = [];
  filteredTagsSuggestions: string[] = [];
  showTagsSuggestions = false;

  // Location variables
  locationSearchControl = new FormControl('');
  locations = [];
  locationSuggestions: string[] = [
  ];
  filteredLocationSuggestions: string[] = [];
  showLocationSuggestions = false;
  @ViewChild('tagsInput', { static: false }) tagsInputElement!: ElementRef;
  @ViewChild('locationInput', { static: false }) locationInputElement!: ElementRef;

  // Selected location
  selectedLocation: string | null = null;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private http: HttpClient,
    private route: ActivatedRoute,
    private authService: AuthService) { }

  ngOnInit(): void {

    if (!localStorage.getItem('company_' + this.businessID)) {
      this.fetchCompanyData();
    }

    //get quwery params tabid
    this.route.queryParams.subscribe(params => {
      //if params are included
      if (params.location || params.jobtitles || params.skills || params.workPossibility) {

        //if some is not filled fill with all
        if (!params.location) {
          params.location = 'every';
        }
        if (!params.jobtitles) {
          params.jobtitles = 'all';
        }
        if (!params.workPossibility) {
          params.workPossibility = 'all';
        }
        if (!params.skills) {
          params.skills = 'all';
        }

        this.contains_query_params = true;

        //make querystting
        var query = '?location=' + params.location + '&jobtitles=' + params.jobtitles + '&workPossibility=' + params.workPossibility + '&skills=' + params.skills;
        //change input values to corresponding values
        this.fetchTags(query);
        this.fetchWishListProfiles(query);
      }
      else {
        var query = '?location=every&jobtitles=all&workPossibility=all&skills=all';

        this.fetchWishListProfiles(query);
      }
    });

    // Tags input value changes
    this.tagsSearchControl.valueChanges
      .pipe(debounceTime(300))
      .subscribe((value) => this.filterTagsSuggestions(value));

    // Location input value changes
    this.locationSearchControl.valueChanges
      .pipe(debounceTime(300))
      .subscribe((value) => this.filterLocationSuggestions(value));
  }



  fetchCompanyData() {
    this.http.get(environment.USER_BUSINESS, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          localStorage.setItem('company_' + this.businessID, JSON.stringify(res.message));

        }
        else {
          var anElm = document.getElementById('notadded');
          anElm.style.display = "block";
        }

      }, (err: any) => {

      })
  }

  loadMoreProfiles() {
    this.currentSkip += 50;

    var skills_ids = this.tags
    .filter(item => item.type === 'skill')
    .map(item => item._id)
    .join(','); // Join with a comma

  var jobtitles_ids = this.tags
    .filter(item => item.type === 'job_title')
    .map(item => item._id)
    .join(','); // Join with a comma

  var locations_ids = this.locations
    .map(item => item.id)
    .join(','); // Join with a comma

  if (!skills_ids) {
    skills_ids = 'all';
  }
  if (!jobtitles_ids) {
    jobtitles_ids = 'all';
  }
  if (!locations_ids) {
    locations_ids = 'every';
  }

    var query = "?location=" + locations_ids + "&jobtitles=" + jobtitles_ids + "&skills=" + skills_ids + "&workPossibility=all&skip=" + this.currentSkip;
    this.fetchWishListProfiles(query);

  }

  fetchTags(query) {
    console.log('fetch tags', query)
    this.http.get(environment.TAGS + query, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.tags = res.message.tags;
          this.locations = res.message.locations;

        }
        else {
          console.log('buu')
        }
      }, (err: any) => {
      })
  }


  fetchWishListProfiles(query) {
    this.http.get(environment.WISHLIST_PROFILES + query, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {

          if (res.message.length == 0) {
            this.isLoading = true;
          }

          for (let i = 0; i < res.banners.length; i++) {
            var banner = res.banners[i];

            Object.assign(banner, { type: 'banner' })

          }
          //combine banners and wishes so that every third element is banner
          var combined = [];
          var b = 0;
          var w = 0;

          for (let i = 0; i < res.banners.length + res.message.length; i++) {
            if (i % 10 == 0 && b < res.banners.length) {
              // Get random banner based on the length of banners array
              var randomBannerIndex = Math.floor(Math.random() * res.banners.length);
              combined.push(res.banners[randomBannerIndex]);
            } else if (w < res.message.length) {
              // Push message and increment message index
              combined.push(res.message[w]);
              w++;
            }
          }

          console.log(combined)

          for (let i = 0; i < combined.length; i++) {
            var elm = combined[i];

            if (elm["type"] != 'banner') {

              Object.assign(elm, { type: 'wish' })

              //Count open profiles
              if (elm.can_open) {
                this.open_profiles += 1;
              }

            }
          }

          if (this.currentSkip > 0) {
            //push new results to last
            for (let i = 0; i < res.message.length; i++) {
              const element = res.message[i];
              this.wishList.push(element);
            }
          }
          else {
            this.wishList = combined;
          }

        }
        else {
          this.out_of_results = true;
          this.wishList = this.wishList;
        }

      }, (err: any) => {

      }
    )

  }

  wellFareAreaSelected(e) {
    var mdid = e.target.id;
    var subgroup = (<HTMLInputElement>document.getElementById(mdid)).value;

    for (let i = 0; i < this.wellfareAreas.length; i++) {
      const group = this.wellfareAreas[i];

      if (group._id == subgroup) {

      }

    }

  }

  markCurrentProfile(data) {
    this.currentProfile = data;
    document.getElementById('open-confirm').click();
  }

  openProfile(data) {
    var req = {
      userID: data.user.userID,
      wishListID: data._id,
      type: 'wishlist_profile_opening'
    }


    this.http.post(environment.OPEN_WHISLIST_PROFILE, req, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.routeProfile(data);
        }
        else {
          console.log('buu')
        }

      }, (err: any) => {

      }
    )
  }

  fetchContacted(type, id, userID) {

    var req = {
      businessID: this.businessID,
      id: id,
      type: type,
      userID: userID,
    }
    this.contacted_by = [];

    this.http.post(environment.MESSAGES_CONTACTED_BY, req, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.contacted_by = res.message;
        }
        else {
          this.opening;
        }

      }, (err: any) => {

      }
    )
  }

  fetchWishlist(data) {
    var req = {
      businessID: this.businessID,
      wishListID: data._id
    }

    this.http.post(environment.VALIDATE_WISHLIST_OPEN + '/' + data.userID, req, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          var opening = res.message
          this.fetchContacted('wishlist', req.wishListID, data.userID)


          var languages_obj_array = opening.languages;
          var display_lang_str = "";
          var display_school_str = "";

          if(languages_obj_array.length > 0){
            for (let i = 0; i < languages_obj_array.length; i++) {
              var lang = languages_obj_array[i];
              display_lang_str += lang.name_fi + ', ';
            }

            display_lang_str = display_lang_str.slice(0, -2);
          }
          
          if(opening.profile?.schools?.length > 0){
          for (let i = 0; i < opening.profile.schools.length; i++) {
            var school = opening.profile.schools[i];
            display_school_str += school.school_name + ', ';
          }
          display_school_str = display_school_str.slice(0, -2);
          }

          opening.display_lang = display_lang_str;
          opening.display_school = display_school_str;

          this.opening = opening;

          //this.selectBG(opening.mdTypeID,opening);
          this.opening = opening;
          document.getElementById('oc-profile').click();

          this.isValid = true;
        }
        else {
          console.log('buu')
          this.opening;
        }

      }, (err: any) => {

      }
    )
  }

  routeProfile(data) {
    console.log(data);
    this.fetchWishlist(data);
  }



  filterProfiles(query) {
    var query_string;
    if (query == '') {
      var selectedWellfareArea = (<HTMLSelectElement>document.getElementById('wellfare-area')).value;
      var selectedMdType = this.selectedMdType;
      if (!<HTMLSelectElement>document.getElementById('work-possibilities')) {
        var selectedWorkpossibility = 'all';
      }
      else {
        var selectedWorkpossibility = (<HTMLSelectElement>document.getElementById('work-possibilities')).value;
      }


      query_string = '?wellfareArea=' + selectedWellfareArea + '&mdType=' + selectedMdType + '&workPossibility=' + selectedWorkpossibility;
    }
    else {
      query_string = query;
    }
    //add query string to current url

    this.router.navigate(['/' + this.businessID + '/wishlists'], {
      queryParams: {
        wellfareArea: selectedWellfareArea,
        mdType: selectedMdType,
        workPossibility: selectedWorkpossibility,
      }
    });

  }

  onSearchMdType() {
    var elm = (<HTMLInputElement>document.getElementById('md-type'));
    var input = (<HTMLInputElement>document.getElementById('md-type')).value;
    if (input.length < 2) {
      if (input.length == 0) {
        this.selectedMdType = 'all';
        this.filterProfiles('');
      }
      this.show_mdtypes = [];
      return;
    }
    else {
      //use el.name_fi or el.grouping_name_fi
      var search = input.toLowerCase();
      var result = this.mdTypes.filter(function (el) {
        //el.name_fi or el.grouping_name_fi
        return el.name_fi.toLowerCase().includes(search) || el.grouping_name_fi.toLowerCase().includes(search);
      });
      this.show_mdtypes = result;

    }
  }


  routeAd(data) {
    this.http.get(environment.PARAMS_INCREASE_BANNER_CLICKS + `?id=${data.id}`, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          //open in new tab data.link
          window.open(data.link, '_blank');
        }
        else {
          console.log('buu')
        }
      }, (err: any) => {
      })
    console.log(data);
  }

  sendMessage() {

    var openingMdType;
    var profilePicture;

    profilePicture = this.opening['profile']['profilePicture'];

    var req = {
      openingID: this.opening._id,
      firstName: this.opening.profile.firstName,
      mdType: {},
      logo: this.opening.logo,
      userID: this.opening.userID,
      type: 'wishlist',
      businessID: this.businessID,
      profilePicture: profilePicture,
    }

    this.http.post(environment.MESSAGE_LIST, req, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.routeMessages(res.message[0]._id)
        }
        else {
          console.log('buu')
        }

      }, (err: any) => {

      }
    )
  }

  routeMessages(id) {
    console.log(id);
    localStorage.setItem('ACTIVE_MSG_LIST', JSON.stringify(id));
    this.router.navigate(['/' + this.businessID + '/messages']);
  }

  saveProfileToList(data, type) {
    console.log(data, 1);
    
    if(type == 'oc'){
      data.userID = data._id
    }
    this.storable_profile = data;
    this.already_in_list = [];

    this.http.get(environment.EMPLOYER_LISTS, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.employer_lists = res.message;
          document.getElementById('save-list').click();

          this.already_in_list = this.employer_lists
            .filter(item =>
              item.profiles && item.profiles.some(profile => profile._id === data.userID)
            )
            .map(item => ({
              id: item._id,
              name: item.name
            }));

          console.log(this.already_in_list, 2)
        }
        else {
          this.employer_lists = [];
          document.getElementById('save-list').click();
          console.log('buu')
        }

      }, (err: any) => {

      }
    )
  }

  saveToList() {
    var storable_profile = this.storable_profile;

    //find selected lists
    var selected_lists = this.employer_lists.filter(x => x.selected == true);
    console.log(selected_lists, storable_profile, 3);

    if (selected_lists.length == 0) {
      alert('Valitse lista');
      return;
    }

    //Check if profile is already in selected list
    var is_in_list = false;
    for (let i = 0; i < selected_lists.length; i++) {
      const list = selected_lists[i];
      if (list.profiles.some(profile => profile._id === storable_profile.userID)) {
        is_in_list = true;
      }
    }

    if (is_in_list) {
      alert('Profiili on jo valitsemissasi listoissa');
      return;
    }

    var selected_lists_ids = selected_lists.map(x => x._id);

    var req = {
      lists: selected_lists_ids,
      userID: storable_profile.userID
    }

    this.http.post(environment.SAVE_PROFILE_TO_LIST, req, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          console.log(res);
          document.getElementById('close-save-list').click();
        }
        else {
          console.log('buu')
        }

      }, (err: any) => {
        console.log(err)
      })
  }

  selectList(list) {

    for (let i = 0; i < this.employer_lists.length; i++) {
      var elm = this.employer_lists[i];

      if (elm._id == list._id) {
        elm.selected = !elm.selected;
      }

    }

  }

  createANewList() {
    var selected_right = this.rights.filter(x => x.selected == true);
    var title = (<HTMLInputElement>document.getElementById('list-title')).value;
    var description = (<HTMLInputElement>document.getElementById('list-description')).value;

    var req = {
      title: title,
      description: description,
      right: selected_right[0].id,
      profiles: [this.storable_profile.userID],
      can_be_seen_by_others_in_same_business: selected_right[0].can_be_seen_by_others_in_same_business,
    }

    //Save list 

    this.http.post(environment.EMPLOYER_LISTS, req, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          console.log(res);
          document.getElementById('close_create_new_list').click();
          setTimeout(() => {
            document.getElementById('list-created').click();
          }, 100);
        }
        else {
          console.log('buu')
        }

      }, (err: any) => {

      }
    )
  }

  selectRight(right) {
    for (let i = 0; i < this.rights.length; i++) {
      const elm = this.rights[i];
      elm.selected = false;
    }

    for (let i = 0; i < this.rights.length; i++) {
      var elm = this.rights[i];
      if (elm == right) {
        elm.selected = true;
      }
    }

    console.log(this.rights)

  }

  addSingleProfileToList(data) {
    var profileID = data._id;
    var req = {
      profileID: profileID,
      listID: data._id
    }
  }

  removeItemFromList(item) {
    console.log(item, this.storable_profile);
    var req = {
      profileID: this.storable_profile.userID,
      lists: [item.id]
    }

    this.http.post(environment.REMOVE_PROFILE_FROM_LIST, req, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          console.log(res);
          //Remove all lists from already_in_list
          for (let i = 0; i < this.already_in_list.length; i++) {
            var person = this.already_in_list[i];

            if (person.id == item.id) {
              this.already_in_list.splice(i, 1);
            }

          }
        }
        else {
          console.log('buu')
        }

      }, (err: any) => {

      }
    )

  }

  routeToLists(){
    //Close modal
    document.getElementById('close-list-created').click();
    //Route to lists
    this.router.navigate(['/' + this.businessID + '/lists']);
  }




  // Filter tags suggestions
  filterTagsSuggestions(query: string): void {
    if (!query) {
      this.filteredTagsSuggestions = [];
      this.showTagsSuggestions = false;
      return;
    }


    //Use api to get suggestions

    this.http.get(environment.TAGS_SUGGESTIONS + '?query=' + query, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.filteredTagsSuggestions = res.message;
          this.showTagsSuggestions = true; // Ensure suggestions are visible
        }
        else {
          console.log('buu')
        }

      }, (err: any) => {

      }
    )
    this.showTagsSuggestions = true; // Ensure suggestions are visible
  }

  // Add a tag
  addTag(tag: string): void {
    if (tag && !this.tags.includes(tag)) {
      this.tags.push(tag);
      this.scrollToEnd(this.tagsInputElement.nativeElement); // Scroll to the end of the tags wrapper
    }
    this.clearTagsSearch(); // Clear the input and suggestions
    this.refocusInput(this.tagsInputElement.nativeElement); // Automatically refocus the input
  }

  addTagEnter() {
    //Select the first suggestion
    if (this.filteredTagsSuggestions.length > 0) {
      this.addTagFromSuggestion(this.filteredTagsSuggestions[0]);
    }
  }

  addTagFromSuggestion(suggestion: string): void {
    console.log('Suggestion:', suggestion);
    this.addTag(suggestion);
    this.showTagsSuggestions = false;
  }

  removeTag(index: number): void {
    this.tags.splice(index, 1);
  }

  clearTagsSearch(): void {
    this.tagsSearchControl.setValue(''); // Clear the input
    this.filteredTagsSuggestions = []; // Clear the suggestions
  }

  // Utility methods for refocusing and scrolling
  refocusInput(inputElement: HTMLElement): void {
    setTimeout(() => {
      inputElement.focus(); // Refocus the input field
    }, 0);
  }


  scrollToEnd(wrapperElement: HTMLElement): void {
    if (wrapperElement) {
      wrapperElement.scrollLeft = wrapperElement.scrollWidth; // Scroll to the end
    }
  }

  handleTagsKeyDown(event: KeyboardEvent): void {
    const inputValue = this.tagsSearchControl.value.trim();

    if (event.key === 'Enter' && inputValue) {
      this.addTag(inputValue);
      event.preventDefault(); // Prevent form submission
    }
  }

  hideLocationSuggestions(): void {
    setTimeout(() => {
      this.showLocationSuggestions = false; // Delayed hiding to allow suggestion click
    }, 200);
  }

  // Add a location
  addLocation(location: string): void {
    if (location && !this.locations.includes(location)) {
      this.locations.push(location);
      this.scrollToEnd(this.locationInputElement.nativeElement.parentElement); // Scroll to the end of the locations wrapper
    }
    this.clearLocationSearch(); // Clear the input and suggestions
    this.refocusInput(this.locationInputElement.nativeElement); // Automatically refocus the input
  }

  addLocationEnter() {
    //Select the first suggestion
    if (this.filteredLocationSuggestions.length > 0) {
      this.addLocationFromSuggestion(this.filteredLocationSuggestions[0]);
    }
  }

  addLocationFromSuggestion(suggestion: string): void {
    this.addLocation(suggestion);
    this.showLocationSuggestions = false; // Hide suggestions after adding
  }


  clearLocationSearch(): void {
    this.locationSearchControl.setValue(''); // Clear the input
    this.filteredLocationSuggestions = []; // Clear the suggestions
  }

  removeLocation(index: number): void {
    this.locations.splice(index, 1);
  }


  // Filter location suggestions
  filterLocationSuggestions(query: string): void {
    if (!query) {
      this.filteredLocationSuggestions = [];
      this.showLocationSuggestions = false;
      return;
    }

    this.http.get(environment.AREAS_SEARCH + '?lang=fi&query=' + query, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.filteredLocationSuggestions = res.message;
          this.showLocationSuggestions = true; // Ensure suggestions are visible
        }
        else {
          console.log('buu')
        }

      }, (err: any) => {

      }
    )
  }


  hideTagsSuggestions(): void {
    setTimeout(() => {
      this.showTagsSuggestions = false;
    }, 200);
  }


  selectLocation(location: string): void {
    if (location) {
      this.locationSearchControl.setValue(''); // Clear the input
      this.filteredLocationSuggestions = []; // Clear the suggestions
      this.showLocationSuggestions = false; // Hide suggestions after selection
      console.log('Selected location:', location);
    }

    // Refocus the input for new search
    setTimeout(() => {
      const locationInputElement = document.querySelector(
        '.location-input'
      ) as HTMLElement;
      locationInputElement?.focus();
    }, 0);
  }


  onSearch(): void {
    console.log('Tags:', this.tags);
    console.log('Location:', this.locations);

    var skills_ids = this.tags
      .filter(item => item.type === 'skill')
      .map(item => item._id)
      .join(','); // Join with a comma

    var jobtitles_ids = this.tags
      .filter(item => item.type === 'job_title')
      .map(item => item._id)
      .join(','); // Join with a comma

    var locations_ids = this.locations
      .map(item => item.id)
      .join(','); // Join with a comma

    if (!skills_ids) {
      skills_ids = 'all';
    }
    if (!jobtitles_ids) {
      jobtitles_ids = 'all';
    }
    if (!locations_ids) {
      locations_ids = 'every';
    }

    console.log('Skills:', skills_ids, 'Job titles:', jobtitles_ids, 'Locations:', locations_ids);

    this.router.navigate(['/' + this.businessID + '/users/home'], {
      queryParams: {
        skills: skills_ids,
        jobtitles: jobtitles_ids,
        location: locations_ids,
        workPossibility: 'all',
      },
    });

  }

  createANewSearchAlert(){
    console.log(this.tags, this.locations)
    var title = (<HTMLInputElement>document.getElementById('search-alert-title')).value;
    var skills = this.tags
    .filter(item => item.type === 'skill') // Keep only items with type 'skill'
    .map(item => item._id); 

    var jobtitles = this.tags
    .filter(item => item.type === 'job_title') // Keep only items with type 'skill'
    .map(item => item._id); 

    if(title.length == 0){
      alert('Anna nimi')
      return;
    }

    if(skills.length == 0 && jobtitles.length == 0 && this.locations.length == 0){
      alert('Valitse vähintään tietotaito, työnimike tai sijainti')
      return;
    }

    var req = {
      name: title,
      skills: skills,
      jobtitles: jobtitles,
      locations: this.locations.map((item) => item.id)
    }

    console.log(req)

    this.http.post(environment.SEARCH_ALERT, req, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          console.log(res);
          document.getElementById('close-add-search-alert').click();
          setTimeout(() => {
            document.getElementById('search-alert-created').click();
          }, 100);
        }
        else {
          console.log('buu')
        }

      }, (err: any) => {

      }
    )

  }

  routeToSearchAlerts(){
    //Close modal
    document.getElementById('close-confirm-search-alert').click();
    //Route to lists
    this.router.navigate(['/' + this.businessID + '/search-alerts']);
  }






}
